import { render } from "./BudgetPercentageModal.vue?vue&type=template&id=23b271a9"
import script from "./BudgetPercentageModal.vue?vue&type=script&lang=js"
export * from "./BudgetPercentageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__